import { faGasPump } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CardPostoContainer } from './styled'
import { FornecedorItens } from '../../../../../../services/Fornecedores'
import { montarEndereco } from '../../../meta'
import { gerarKey, maskCNPJ } from '../../../../../../utils'

//PROPS
interface Props {
  /**Posto do cadastro de fornecedores que está selecionado no formulário */
  posto: FornecedorItens
}

/**Card com os dados do posto cadastrado, mostrado no lugar dos campos de nome, cnpj e endereço
 * quando o usuário seleciona um posto da lista
*/
export const CardPosto: React.FC<Props> = ({ posto }) => {
  /**Só aparecem as informações que o fornecedor tem preenchidas */
  const infos = [
    { titulo: 'CNPJ', valor: maskCNPJ(posto?.cpf_cnpj) },
    { titulo: 'Endereço', valor: montarEndereco(posto) },
    { titulo: 'Telefone', valor: posto?.fone },
    { titulo: 'E-mail', valor: posto?.email },
  ].filter((info) => !!info.valor)

  return (
    <CardPostoContainer>
      <div className='CardPosto__cabecalho'>
        <div className='CardPosto__cabecalho__icone'>
          <FontAwesomeIcon icon={faGasPump} />
        </div>
        <div>
          <span className='CardPosto__cabecalho__legenda'>Posto cadastrado</span>
          <p className='CardPosto__cabecalho__nome'>{posto?.nome}</p>
        </div>
      </div>

      {infos.length > 0 && (
        <div className='CardPosto__infos'>
          {infos.map(({ titulo, valor }, index) => (
            <div className='CardPosto__infos__item' key={gerarKey(index)}>
              <p className='CardPosto__infos__item__titulo'>{titulo}</p>
              <span className='CardPosto__infos__item__valor'>{valor}</span>
            </div>
          ))}
        </div>
      )}
    </CardPostoContainer>
  )
}
